import { render, staticRenderFns } from "./TravelsTableHeader.vue?vue&type=template&id=77f3229a&"
import script from "./TravelsTableHeader.vue?vue&type=script&lang=js&"
export * from "./TravelsTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports